if (!customElements.get('cart-drawer-upsell')) {
  class CartDrawerUpsell extends HTMLElement {
    constructor() {
      super();
      if ('requestIdleCallback' in window) {
        requestIdleCallback(this.init.bind(this), { timeout: 1500 });
      } else {
        const userAgent = navigator.userAgent;
        const isSafari = userAgent.includes('Safari') && !userAgent.includes('Chrome');
        if (isSafari) {
          this.init();
        } else {
          FoxTheme.Motion.inView(this, this.init.bind(this), { margin: '600px 0px 600px 0px' });
        }
      }
    }

    get slideContainer() {
      return this.querySelector('.swiper');
    }

    get sliderPagination() {
      return this.querySelector('.swiper-pagination');
    }

    get sliderNext() {
      return this.querySelector('.swiper-button-next');
    }

    get sliderPrev() {
      return this.querySelector('.swiper-button-prev');
    }

    init() {
      if (!this.dataset.url) return;
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((responseText) => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(responseText, 'text/html')
            .querySelector('.shopify-section');

          if (sectionInnerHTML === null) return;

          const upsell = sectionInnerHTML.querySelector('cart-drawer-upsell');
          if (upsell && upsell.innerHTML.trim().length) {
            const productCount = upsell.querySelectorAll('.product-card');
            this.innerHTML = upsell.innerHTML;
            this.initCarousel();
            if (productCount.length > 0) this.classList.remove('hidden');
            this.dispatchEvent(new CustomEvent('upsell:loaded'));
          } else {
            this.classList.add('hidden');
            this.dispatchEvent(new CustomEvent('is-empty'));
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }

    initCarousel() {
      this.carousel = new FoxTheme.Carousel(this.slideContainer, {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: false,
        pagination: {
          el: this.sliderPagination,
          type: 'fraction',
        },
        navigation: {
          nextEl: this.sliderNext,
          prevEl: this.sliderPrev,
        },
      });

      this.carousel && this.carousel.init();
    }
  }

  customElements.define('cart-drawer-upsell', CartDrawerUpsell);
}
